<template>
  <div v-if="upcomingWorkshop.length">
    <h2 class="mt-7 text-2xl font-bold">
      {{ upcomingWorkshop.length > 1 ? `Upcoming workshops:` : 'Upcoming workshop:' }}
    </h2>
    <div v-for="workshop in upcomingWorkshop" :key="workshop.slug">
      <NuxtLink
        :to="`/workshop/${workshop.slug}`"
        class="mt-5 block bg-ivory-dark p-5"
        :data-testid="`sidebar-workshop-${workshop.slug}`"
        @click="useTrackEvent('sidebarWorkshopClick')"
      >
        <Image :src="workshop.image" :alt="workshop.title" />
        <h2 class="text-2xl font-extrabold">
          {{ workshop.title }}
        </h2>
        <p class="text-gray-400">
          {{ workshop.workshop_dates?.days }}
        </p>
        <p>{{ workshop.workshop_dates?.date_display }}</p>
        <button class="mt-5 w-full bg-white px-7 py-3 text-xl font-black uppercase hover:shadow-block-lime transition-all border-2 border-border">
          Register here
        </button>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
const { getUpcomingWorkshops } = useSupabaseWorkshops()

const { data } = await useAsyncData('upcoming-workshops-sidebar', async () => {
  const { workshops, error } = await getUpcomingWorkshops()
  if (error) {
    console.error('Error fetching upcoming workshops:', error)
    return []
  }
  return workshops || []
})

const upcomingWorkshop = computed(() => data.value || [])
</script> 